import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "@/components/LanguageContext";

export default function FAQSection() {
  const { t } = useTranslation();
  const faqs = [
    { q: t("faq.q1"), a: t("faq.a1") },
    { q: t("faq.q2"), a: t("faq.a2") },
    { q: t("faq.q3"), a: t("faq.a3") },
    { q: t("faq.q4"), a: t("faq.a4") },
    { q: t("faq.q5"), a: t("faq.a5") },
  ];
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00A8FF] mb-2">{t("faq.label")}</p>
          <div className="section-divider mx-auto mb-6" />
          <h2 className="font-['Outfit'] text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A1628]">{t("faq.title")}</h2>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-100" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-['Outfit'] text-[15px] font-bold text-[#0A1628] hover:no-underline py-5">{faq.q}</AccordionTrigger>
              <AccordionContent className="text-sm text-slate-500 leading-relaxed pb-5">{faq.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
